import $ from 'jquery';
window.$ = $;

$('.dropdown-menu').hide();

$('body').on('click touchstart', '.dropdown', function(event) {
  if (event.handled === false) return;
  event.stopPropagation();
  event.preventDefault();
  event.handled = true;
  $(this)
    .attr('tabindex', 1)
    .focus();
  $(this).toggleClass('active');
  $(this)
    .find('.dropdown-menu')
    .slideToggle(300);
});
$('.dropdown').focusout(function() {
  $(this).removeClass('active');
  $(this)
    .find('.dropdown-menu')
    .slideUp(300);
});
$('.dropdown .dropdown-menu li').click(function() {
  $(this)
    .parents('.dropdown')
    .find('.select span')
    .first()
    .text($(this).text());
  $(this)
    .parents('.dropdown')
    .find('input')
    .attr('value', $(this).attr('id'));
});
